export default __webpack_public_path__ + "static/media/Covalent.8331104b.png";